export function triggerAnalyticsEvent(eventData, eventName="gaDonateWidgetEvent") {
    const event = new CustomEvent(eventName, {
        detail: eventData,
    });
    document.dispatchEvent(event);
}